import * as React from 'react';

export const ElectricityIcon = () => (
  <svg width="128" height="128" viewBox="0 0 128 128">
    <defs>
      <path
        id="electricity-icon-a"
        d="M127.975479,63.9872936 C127.975479,99.3266183 99.3259494,127.973918 63.9866249,127.973918 C28.6473006,127.973918 0,99.3266183 0,63.9872936 C0,28.6479694 28.6473006,0.000668754747 63.9866249,0.000668754747 C99.3259494,0.000668754747 127.975479,28.6479694 127.975479,63.9872936"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="electricity-icon-b" fill="#fff">
        <use xlinkHref="#electricity-icon-a" />
      </mask>
      <use fill="#F7F7F7" fill-rule="nonzero" xlinkHref="#electricity-icon-a" />
      <rect
        width="3.52"
        height="18"
        x="62.792"
        y="-9.368"
        fill="#FA4616"
        fill-rule="nonzero"
        mask="url(#electricity-icon-b)"
      />
      <g fill="#FFC72C" fill-rule="nonzero" mask="url(#electricity-icon-b)">
        <g transform="translate(29 73.84)">
          <rect width="6.424" height="12.936" x="32.208" y="16.28" />
          <rect
            width="6.424"
            height="12.936"
            x="48.289"
            y="12.072"
            transform="rotate(-30.001 51.5 18.54)"
          />
          <rect
            width="6.424"
            height="12.936"
            x="60.373"
            y=".141"
            transform="rotate(-59.999 63.585 6.609)"
          />
          <rect
            width="12.936"
            height="6.424"
            x="12.68"
            y="15.077"
            transform="rotate(-59.994 19.148 18.289)"
          />
          <rect
            width="12.936"
            height="6.424"
            x=".798"
            y="3.54"
            transform="rotate(-29.993 7.266 6.752)"
          />
        </g>
      </g>
      <g fill-rule="nonzero" mask="url(#electricity-icon-b)">
        <g transform="translate(43.08 7.84)">
          <path
            fill="#FFC72C"
            d="M21.5599992,77.2639971 C9.94399962,77.2639971 0.52799998,67.8479974 0.52799998,56.2319979 C0.52799998,50.4239981 2.90399989,45.1439983 6.68799975,41.3599984 C6.95199974,41.0959984 7.21599973,40.8319985 7.56799971,40.4799985 C9.06399966,39.0719985 11.8799995,36.6079986 13.4639995,35.0239987 C15.0479994,33.4399987 14.9599994,32.0319988 14.9599994,30.0959989 C14.9599994,28.8639989 14.8719994,27.103999 15.4879994,26.663999 L21.5599992,26.663999 L27.631999,26.663999 C28.3359989,27.103999 28.1599989,28.8639989 28.1599989,30.0959989 C28.1599989,32.1199988 28.0719989,33.5279987 29.6559989,35.0239987 C31.2399988,36.5199986 34.0559987,39.0719985 35.5519987,40.4799985 C35.8159986,40.7439985 36.1679986,41.0079984 36.4319986,41.3599984 C40.2159985,45.1439983 42.5919984,50.4239981 42.5919984,56.2319979 C42.5919984,67.8479974 33.1759987,77.2639971 21.5599992,77.2639971"
          />
          <path
            fill="#3C3C3C"
            d="M14.6959994,29.6559989 L13.1119995,27.9839989 L13.1119995,10.4719996 C13.1119995,10.4719996 15.3999994,10.0319996 17.1599993,8.27199969 C19.0079993,6.42399976 18.8319993,3.95999985 18.8319993,0.52799998 L21.4719992,0.52799998 L24.1119995,0.52799998 C24.1119995,3.95999985 23.9359991,6.42399976 25.783999,8.27199969 C27.455999,10.0319996 29.8319989,10.4719996 29.8319989,10.4719996 L29.8319989,27.9839989 L28.2479989,29.6559989 L21.4719992,29.6559989 L14.6959994,29.6559989 L14.6959994,29.6559989 Z"
          />
          <polygon
            fill="#736F6F"
            points="14.696 31.592 13.2 27.984 29.92 27.984 28.336 31.592 21.56 31.592"
          />
          <path
            fill="#FFDC7A"
            d="M21.5599992,71.7199973 C12.8479995,71.7199973 5.71999978,64.5919976 5.71999978,55.8799979 L16.2799994,55.8799979 C16.2799994,58.8719978 18.6559993,61.2479977 21.6479992,61.2479977 C24.5519991,61.2479977 27.015999,58.8719978 27.015999,55.8799979 L37.5759986,55.8799979 C37.3999986,64.6799975 30.2719989,71.7199973 21.5599992,71.7199973"
          />
        </g>
      </g>
    </g>
  </svg>
);
